import 'core-js/modules/es.regexp.to-string.js';
import '../domain/dtos/asset-status.js';
import { AssetImageSubType, AssetApplicationSubType, AssetVideoSubType } from '../domain/dtos/asset-subtype.js';
import { AssetType } from '../domain/dtos/asset-type.js';
import '../domain/dtos/query-key.js';
import '../domain/dtos/upload-status.js';
import { Envs } from '../envs.js';

const getValidFileExtensions = field => {
  let data = [];
  if (field === 'mainMedia') {
    data = Object.values(AssetImageSubType).map(item => `${AssetType.image}/${item}`);
    data = data.concat(Object.values(AssetApplicationSubType).map(item => `${AssetType.application}/${item}`), Object.values(AssetVideoSubType).map(item => `${AssetType.video}/${item}`));
  } else if (field === 'attachments') {
    data = [Envs.ATTACHMENT_FILE_MIMETYPE_ALLOWED, Envs.ATTACHMENT_IMAGE_MIMETYPE_ALLOWED, Envs.ATTACHMENT_VIDEO_MIMETYPE_ALLOWED];
  } else if (field === 'videoAsset') {
    data = [Envs.ATTACHMENT_VIDEO_MIMETYPE_ALLOWED];
  } else if (field === 'customCover' || field === 'desktopAsset' || field === 'mobileAsset') {
    data = [Envs.ATTACHMENT_IMAGE_MIMETYPE_ALLOWED];
  }
  return data.toString();
};

export { getValidFileExtensions };
